import React from 'react';

import { GraphQLClient } from 'graphql-request';
import Header from 'components/__dynamic/header';
const hygraphClient = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHCMS);
import { dynamicPageSlug, navigationInfo } from 'components/utils';
import Footer from 'components/__dynamic/footer';
import { PageBuilder } from 'components/__dynamic/pagebuilder';
import Layout from 'components/Layout';
import { useRouter } from 'next/router';

export async function getStaticProps({ params }) {
  const slug = params.slug.slice(-1)[0]; // Get the last element of the slug array

  const { page } = await hygraphClient.request(dynamicPageSlug, {
    slug: slug,
  });

  if (!page) {
    return {
      notFound: true,
    };
  }

  const { navigation } = await hygraphClient.request(navigationInfo);
  return {
    props: { page, navigation },
    revalidate: 2,
  };
}

export async function getStaticPaths() {
  const { pages } = await hygraphClient.request(
    `
      query pages {
          pages:dynamicPages(where: {id_not: "cl8ms98ojyurm0auh9zlay4x8"}) {
              id
              title
              slug
              components {
                ... on SectionPagelister {
                  dynamicPages {
                    slug
                  }
                }
              }
          }
      }
      `
  );

  const paths = [];

  // Loop through the pages and add their paths to the array
  pages.forEach(page => {
    // Add the page's slug as a path
    paths.push({ params: { slug: [page.slug] } });

    // Loop through the page's components and look for dynamic pages
    page.components.forEach(component => {
      if (component.dynamicPages) {
        // Loop through the dynamic pages and add their paths to the array
        component.dynamicPages.forEach(dynamicPage => {
          paths.push({
            params: {
              slug: [page.slug, dynamicPage.slug],
            },
          });
        });
      }
    });
  });

  return {
    paths,
    fallback: 'blocking',
  };
}

export default function Page({ page, navigation }) {
  const router = useRouter(); /* Inside the component */

  return (
    <Layout key={router.asPath} metaData={page?.ogData}>
      <Header
        navigation={navigation}
        backgroundColor="white"
        textColor="figma-secondaryone"
        textColorHover="figma-primary"
        dropdownColor="figma-primary"
      />
      {page?.components?.map((component, id) => (
        <PageBuilder key={id} component={component} />
      ))}
      <Footer navigation={navigation} />
    </Layout>
  );
}
